import BlockOutlinedIcon from "@mui/icons-material/BlockOutlined";
import CelebrationOutlinedIcon from "@mui/icons-material/CelebrationOutlined";
import DraftsOutlinedIcon from "@mui/icons-material/DraftsOutlined";
import GroupsOutlinedIcon from "@mui/icons-material/GroupsOutlined";
import PhoneForwardedOutlinedIcon from "@mui/icons-material/PhoneForwardedOutlined";

import { blue, green, purple, red, teal } from "@mui/material/colors";
import { Column } from "../../types/Column";
import { EvaluationStatus } from "../../types/Contact";

export const boardColumns: Column[] = [
    {
        name: "Candidature",
        icon: <DraftsOutlinedIcon />,
        color: blue,
        status: EvaluationStatus.CANDIDATURE,
    },
    {
        name: "En attente",
        icon: <PhoneForwardedOutlinedIcon />,
        color: teal,
        status: EvaluationStatus.EN_ATTENTE,
    },
    {
        name: "A l'étude",
        icon: <GroupsOutlinedIcon />,
        color: purple,
        status: EvaluationStatus.EN_ETUDE,
    },
    {
        name: "Remerciée",
        icon: <BlockOutlinedIcon />,
        color: red,
        status: EvaluationStatus.REMERCIEE,
    },
    {
        name: "Favorable",
        icon: <CelebrationOutlinedIcon />,
        color: green,
        status: EvaluationStatus.FAVORABLE,
    },
];
